export const messages = {
  playSolo: "Play solo",
  gameInstructions:
    "In this mini game, your goal is to name a random Gwent card from its illustration. The cards used in this game come from <leviathan>Team Leviathan</leviathan>'s latest <meta>meta report</meta>. It's a great way to improve while having fun!",
  difficultyLevel:
    "{difficultyLevel, select, easy {<b>Easy</b>: full illustration, select among 3 choices.} medium {<b>Medium</b>: full illustration, free selection.} hard {<b>Hard</b>: part of the illustration, select among 3 choices.} extreme {<b>Extreme</b>: part of the illustration, free selection.}}",
  play: "Play",
  playWithTwitchChat: "Play with your Twitch chat",
  inspiredBy: "Inspired by <a>Faberstein</a>",
  aboutCode: "About/Code",
  disclaimer:
    "This is an unofficial fan work under the <a>Gwent Fan Content Guidelines</a>. Not approved/endorsed by CD PROJEKT RED.",
  hint: "Hint ({remainCount} left)",
  hintCardType:
    "This is a {cardType, select, unit {unit} special {special} artifact {artifact}} card",
  hintFaction: "owned by {faction}",
  hintInitials: 'with a name starting with "{initials}"',
  gameOver: "Game Over!",
  gameOverSummary:
    "You had {correctAnswers} correct answers out of {totalQuestions}. Feeling proud? Let the world know!",
  tweetText:
    "I just named {correctAnswers} Gwent cards out of the {totalQuestions} random ones. Beat me to it!",
  tweet: "Tweet",
  playAgain: "Play Again",
  questionLabel: "What is the name of this card?",
  placeholder: "Name this card...",
  submit: "Submit",
  won: "Congrats!",
  wonUsername: "Congrats {username}!",
  cardNamed: "This card is named {localizedName}.",
  lost: "Nope.",
  butCardNamed:
    "This card is not named {wrongLocalizedName} but {correctLocalizedName}.",
  breakTimeLeft:
    "{seconds} seconds left before the next question (<a>skip</a>).",
  changeLocaleWhilePlaying:
    "In order to change the current language, the game has to be restarted. Do you want to change the language and restart the game?",
  gameInstructionsTwitchChat:
    "The game is the same. The only difference is that your browser will connect to your Twitch chat and listen to your viewers' message. It will try to match their messages with a card and show the winner on screen if one is found. Your viewers do not have to provide the exact name, the game uses a mechanism to allow for typos.",
  channelRequired: "Your Twitch channel is required to connect to your chat.",
  twitchError:
    "Could not connect to your Twitch chat. Are you sure that you have entered your channel correctly?",
  connecting: "Connecting...",
  morvranTaunt1: "You will like this.",
  morvranTaunt2: "I don't mean to rush you, but...",
  morvranTaunt3: "Forgive me, but I must destroy you.",
  emhyrTaunt1: "Your continued struggle has grown amusing.",
  emhyrTaunt2: "Careful. You do not want me to lose patience.",
  dettlaffTaunt1:
    "Your entire world shall soon lapse into slumber as darkness descends upon it.",
  dettlaffTaunt2: "Get on with it! Move! Now!",
  dettlaffTaunt3: "Do you truly believe that will stop me?",
  woodlandTaunt1: "...",
  eredinTaunt1: "You would make a good slave.",
  eredinTaunt2: "You know well how this will end.",
  eredinTaunt3: "You shall perish, worm.",
  meveTaunt1: "Brace yourself, there'll be no mercy.",
  meveTaunt2: "Careful. I'm losing patience.",
  meveTaunt3: "Really? You think you stand a chance?",
  foltestTaunt1: "Don't give up easy, do you?",
  foltestTaunt2: "Enough! Do something! Stop mucking about!",
  foltestTaunt3: "Grrr, I've had battles go awry, but this topples them all!",
  brouverTaunt1: "Ye waitin' round, hopin I'll croak, ye badger?",
  brouverTaunt2: "Hahaha! Ehh… wait, ye're serious? That's yer move?",
  brouverTaunt3: "Somebody hold me back or I'll…",
};
